import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KidsBuchungMlInfoComponent } from './kids-buchung-ml-info.component';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
  imports: [
    KidsBuchungMlInfoComponent,
    MatDialogActions,
    MatButton,
    MatDivider,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent
  ],
  templateUrl: './kids-buchung-kontakt.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KidsBuchungKontaktComponent {}
